/**
 * Cache Cleanup Middleware
 * Periodically cleans expired cache entries from Redux state
 */

import { cleanExpiredCache as cleanAttractionsCache } from '../ducks/attractions.duck';
import { cleanExpiredCache as cleanEventsCache } from '../ducks/attractionEvents.duck';
import { cleanExpiredCache as cleanListingsCache } from '../ducks/listings.duck';
import { cleanExpiredCache as cleanSalesDataCache } from '../ducks/salesData.duck';

// Clean cache every 5 minutes
const CLEANUP_INTERVAL = 5 * 60 * 1000;

let cleanupTimer = null;

export const cacheCleanupMiddleware = store => next => action => {
  const result = next(action);

  // Initialize cleanup timer on first action
  if (!cleanupTimer && typeof window !== 'undefined') {
    cleanupTimer = setInterval(() => {
      store.dispatch(cleanAttractionsCache());
      store.dispatch(cleanEventsCache());
      store.dispatch(cleanListingsCache());
      store.dispatch(cleanSalesDataCache());
    }, CLEANUP_INTERVAL);
  }

  return result;
};
